import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Building2, LayoutDashboard, Receipt, Calculator, CircleDollarSign, Sparkles, LogOut, FileSearch, FileBarChart2, Plug, CreditCard, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/app", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/app/transactions", label: "Transactions", icon: Receipt },
  { to: "/app/statements", label: "Statements", icon: FileSearch },
  { to: "/app/reports", label: "Reports", icon: FileBarChart2 },
  { to: "/app/tax", label: "Tax Savings", icon: Calculator },
  { to: "/app/debts", label: "Debt", icon: CircleDollarSign },
  { to: "/app/advisor", label: "AI Advisor", icon: Sparkles },
  { to: "/app/integrations", label: "Integrations", icon: Plug },
  { to: "/app/billing", label: "Billing", icon: CreditCard },
  { to: "/app/settings", label: "Settings", icon: SettingsIcon },
];

export default function MobileTopBar() {
  const [open, setOpen] = useState(false);
  const { logout, user } = useAuth();
  return (
    <div className="lg:hidden border-b border-border bg-white">
      <div className="flex items-center justify-between px-4 h-14">
        <Link to="/app" className="flex items-center gap-2" data-testid="mobile-logo">
          <div className="w-7 h-7 rounded-md bg-forest flex items-center justify-center text-white">
            <Building2 className="w-3.5 h-3.5" strokeWidth={1.75} />
          </div>
          <span className="font-heading text-lg font-semibold">BizCashflow <span className="text-forest">Pros</span></span>
        </Link>
        <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" className="p-2 rounded-lg hover:bg-paper">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-border p-3 space-y-1 bg-white" data-testid="mobile-menu">
          {ITEMS.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm ${
                  isActive ? "bg-forest/10 text-forest font-medium" : "text-ink-light"
                }`
              }
            >
              <it.icon className="w-4 h-4" strokeWidth={1.75} />
              {it.label}
            </NavLink>
          ))}
          <button
            onClick={() => { setOpen(false); logout(); }}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-ink-light"
          >
            <LogOut className="w-4 h-4" strokeWidth={1.75} /> Sign out — {user?.name}
          </button>
        </div>
      )}
    </div>
  );
}
